<template>
<!--  <div-->
<!--    class="col-12 col-lg-6 p-3  mr-auto mx-auto mb-3 "-->
<!--    style="-->
<!--      direction: rtl;-->
<!--      text-align: center;-->
<!--      color: #000;-->
<!--      font-size: 16px;-->
<!--      border-radius: 8px;-->
<!--      border: 1px solid rgb(204, 204, 204);-->
<!--      box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px;-->
<!--      background: #fff;-->
<!--    "-->
<!--  >-->
<!--  تا این لحظه-->
<!--    <span id="countup" style="font-weight: bold;" class="bg-primary p-2 pt-1 pb-1  text-white rounded-pill">-->
<!--    </span>-->
<!--    چارت با هورا.-->
<!--  </div>-->
</template>

<script>
import ApiService from "../service/api";
import { CountUp } from 'countup.js';

export default {
  name: "HoraStats",
  props: ["stat_type"],
  components: {
    CountUp
  },
  data() {
    return {
      result: "",
    };
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    countUpView(){

    },
    getData() {
      const options = {
        duration: 3,
      };
      ApiService.getHoraStats(this.stat_type).then((response) => {
        const countUp = new CountUp('countup', response["data"]["all_charts"], options);
        if (!countUp.error) {
          countUp.start();
        }
      });
    },
  },
};
</script>

<style scoped>
.gradient-background {
  background: linear-gradient(160deg,#fbfaf1,#ffffff,#fcf9d5);
  background-size: 180% 180%;
  animation: gradient-animation 18s ease infinite;
}

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
